<template>
  <div class="dark-overlay" @click.self="closeModal">
    <AppLoading />
    <div class="pop-up2">
      <h4>Cancelar</h4>
      <div class="form-group">
        <label for="newDate">Fecha:</label>
        <input
          v-model="band.project.project_date"
          class="form-control"
          type="date"
          id="newDate"
        />
      </div>
      <div class="form-group">
        <label for="comment">Comentario:</label>
        <textarea
          class="form-control"
          id="comment"
          rows="4"
          v-model="band.project.audit_comment"
        />
      </div>
      <br />
      <div class="button-container">
        <button @click="closeModal" class="btn btn-outline-danger btn-long">
          Cerrar
        </button>
        <button
          class="btn btn-outline-light btn-long"
          @click="transitionToNewState"
        >
          Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  toRaw,
  watch,
  onMounted,
  onBeforeUnmount,
  defineProps,
  defineEmits,
  reactive,
} from "vue";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";
import AppLoading from "./AppLoading.vue";

const props = defineProps({
  projectData: {
    type: Object,
    default: () => ({}),
    required: false,
  },
});

const emit = defineEmits(["close"]);
const store = useStore();

function todayLocalYYYYMMDD() {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
}

const band = reactive({
  project: {
    id: null,
    project_date: todayLocalYYYYMMDD(),
    audit_comment: "",
    rape_id: "",
    eta: "",
  },
  title: "Cancelar",
  state: "cancel",
  estimatedHourCount: 0,
  estimatedHoursCount: 0,
});

const handleKeyup = (e) => {
  if (e.key === "Escape") closeModal();
};

const closeModal = () => {
  emit("close");
};

const fetchProjects = async () => {
  store.dispatch("app/showLoading");
  try {
    await store.dispatch("fetchProjects");
  } finally {
    store.dispatch("app/hideLoading");
  }
};

const transitionToNewState = async () => {
  store.dispatch("app/showLoading");
  try {
    const res = await store.dispatch("transitionProjectState", {
      projectId: band.project.id,
      payload: toRaw(band),
    });
    if (res.data.notice) {
      await fetchProjects();
      await closeModal();
      await toast.success(res.data.notice, { autoClose: 4000, theme: "dark" });
    }
  } catch {
    //
  } finally {
    store.dispatch("app/hideLoading");
  }
};

watch(
  () => props.state,
  (val) => {
    if (val != null) band.state = val;
  },
  { immediate: true }
);

watch(
  () => props.projectData,
  (p) => {
    if (!p) return;
    band.project.id = p.id ?? band.project.id;
    band.project.eta = p.eta ?? "";
    band.project.rape_id = p.rape_id ?? "";
  },
  { immediate: true, deep: true }
);

onMounted(async () => {
  window.addEventListener("keyup", handleKeyup);
});

onBeforeUnmount(() => {
  window.removeEventListener("keyup", handleKeyup);
});
</script>

<style>
.dark-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(41, 41, 41, 0.5);
  z-index: 1;
  overflow: auto;
}
.pop-up2 {
  padding: 30px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background-color: #141218;
  border-radius: 20px;
  border: 1px solid #f4641652;
  overflow: auto;
  min-width: 40vw;
  min-height: 40vh;
  max-width: 60vw;
  max-height: 70vh;
  box-sizing: border-box;
}

.button-container {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.btn-long {
  width: 100px;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 200ms ease-in-out;
}
</style>
